import { ArrowUpRight, Clock3 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface PaymentDueBannerProps {
    paymentGracePeriodEndsAt?: string | null;
}

export const PaymentDueBanner = ({
    paymentGracePeriodEndsAt = null,
}: PaymentDueBannerProps) => {
    const { t } = useTranslation();
    const graceDeadline = paymentGracePeriodEndsAt
        ? new Date(paymentGracePeriodEndsAt).toLocaleString()
        : null;
    const description = graceDeadline
        ? t("billing.paymentDue.descriptionWithDeadline", { deadline: graceDeadline })
        : t("billing.paymentDue.description");

    return (
        <div className="border-b border-amber-200 bg-amber-50/90 px-4 py-3 text-amber-950">
            <div className="container mx-auto flex flex-wrap items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                    <div className="flex h-9 w-9 items-center justify-center rounded-md bg-amber-100 text-amber-700">
                        <Clock3 className="h-4 w-4" />
                    </div>
                    <div>
                        <div className="text-sm font-semibold">{t("billing.paymentDue.title")}</div>
                        <div className="text-xs text-amber-800">{description}</div>
                    </div>
                </div>
                <Button
                    asChild
                    variant="outline"
                    size="sm"
                    className="border-amber-300 bg-white/70 text-amber-950 hover:bg-white"
                >
                    <Link to="/company/billing">
                        {t("billing.paymentDue.updateBilling")}
                        <ArrowUpRight className="ml-2 h-3.5 w-3.5" />
                    </Link>
                </Button>
            </div>
        </div>
    );
};
